import React from 'react';
import { Container, Typography, Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ServerErrorScreen(){
  const { t } = useTranslation('ui');
  const navigate = useNavigate();

  const handleHomeClick = () => {
    navigate('/');
  };

  return (
    <Container>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <Typography variant="h1" component="h2" gutterBottom>
          {t('serverError.title')}
        </Typography>
        <Typography variant="h5" component="h3" gutterBottom>
          {t('serverError.heading')}
        </Typography>
        <Typography variant="body1" gutterBottom>
          {t('serverError.message')}
        </Typography>
        <Button variant="contained" color="primary" onClick={handleHomeClick}>
          {t('serverError.goHome')}
        </Button>
      </Box>
    </Container>
  );
}

